<script>
import { Menu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      redirectRoute: null,
      charsetsOptions: [
        {
          label: 'Russian',
          value: 'ru'
        },
        {
          label: 'Thai',
          value: 'th'
        },
        {
          label: 'Japanese',
          value: 'jp'
        },
        {
          label: 'Chinese',
          value: 'zh'
        },
        {
          label: 'Arabic',
          value: 'ar'
        }
      ]
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Formset({
          modelPath: [this, 'form', 'items'],
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['link', 'label_en']),
              fields: [
                new fields.Input({
                  label: 'Subtitle',
                  modelPath: [this, 'form', 'items', i, 'subtitle']
                }),
                new fields.Select({
                  label: 'Special characters set',
                  modelPath: [this, 'form', 'items', i, 'charset'],
                  options: this.charsetsOptions
                }),
                new fields.Link({
                  label: 'Link',
                  modelPath: [this, 'form', 'items', i, 'link']
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return Menu
    }
  }
}
</script>
